import { useMyContext } from 'Context/MyContextProvider';
const PermissionChecker = ({ permission, role, children }) => {
    const { Permisson, userRole } = useMyContext();

    const isRoleMatched = !role || (Array.isArray(role) ? role.includes(userRole) : userRole === role);
    const isPermissionMatched = !permission || userRole === 'Admin' || Permisson?.includes(permission);

    if (isRoleMatched && isPermissionMatched) {
        return children;
    }

    return null;
}

export default PermissionChecker
